<template>
  <div class="images-item-block">
    <!-- 文档文件 -->
    <div v-if="_isDocumentFileFormat(item.url)">
      <a :href="item.url" class="doc-class" />
    </div>
    <!-- PDF文件 -->
    <div v-else-if="_isPDFFileFormat(item.url)">
      <a target="_blank" class="pdf-class" @click="(e) => onNavsToPDFFile(e, item.url)" />
    </div>
    <!-- MP3音频文件 -->
    <div v-else-if="_isMP3FileFormat(item.url)">
      <a target="_blank" class="mp3-class" :href="item.url" />
    </div>
    <!-- 视频文件 -->
    <div v-else-if="checkVideo(item.url)" style="max-width: 400px; max-height: 200px">
      <video
        align="center"
        mediatype="video"
        :preload="video.preload"
        :poster="video.videoImg"
        :height="video.height"
        :width="video.width"
        :controls="video.controls"
        :src="item.url"
      />
    </div>
    <!-- tif、tiff特殊文件 -->
    <div
      v-else-if="_isTifFileFormat(item.url)"
      :id="canvasType + index"
      @click="showImg"
    />

    <div v-else>
      <el-image
        v-if="item.url"
        alt
        lazy
        class="uploader_file img-block"
        fit="cover"
        :src="item.url + '?imageView2/1/w/130/h/130/q/85'"
        :data-original="item.url + '?imageView2/2/w/1200/h/1200/q/85'"
        @click="showImg"
      />
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex'
import Comm from '@/utils/common' // 公用方法
export default {
  name: 'ImageItems',

  props: {
    // 资料内容
    item: {
      type: Object,
      default: () => {}
    },

    // 资料对应的下标值
    index: {
      type: Number,
      default: () => 0
    },

    // 对应的canvas画布类型
    canvasType: {
      type: String,
      default: () => ''
    },

    // 对应的图片类型
    imgType: {
      type: String,
      default: () => ''
    }
  },

  data() {
    return {
      appPath: this.homePath() || '',

      // 视频默认格式
      video: {
        videoImg:
          'http://ehuzhu-1251082375.cos.ap-guangzhou.myqcloud.com/cms/7c6c9485913cc8c91ae8.png',
        playStatus: '',
        muteStatus: '',
        isMute: true,
        isPlay: false,
        width: '125', // 设置视频播放器的显示宽度（以像素为单位）
        height: '125', // 设置视频播放器的显示高度（以像素为单位）
        preload: 'auto', //  建议浏览器是否应在<video>加载元素后立即开始下载视频数据。
        controls: true // 确定播放器是否具有用户可以与之交互的控件。没有控件，启动视频播放的唯一方法是使用autoplay属性或通过Player API。
      },
      // 视频/音频文件格式
      imageTypes: [
        'mp4',
        'MP4',
        'wma',
        'mpeg',
        'avi',
        'mov',
        'flv',
        'f4v',
        'rmvb',
        'mp3'
      ]
    }
  },

  computed: {
    ...mapState({
      caseInfo: (state) => state.caseDetail.caseInfo
    })
  },

  methods: {
    /**
     * 检查视频/音频文件格式是否正确
     * @param {string} url 文件的网络地址
     */
    checkVideo(url) {
      let type = url.substring(url.lastIndexOf('.') + 1, url.length)
      type = this._caseConversion(type)
      return this.imageTypes.indexOf(type) !== -1
    },

    /**
     * 预览图片
     */
    showImg() {
      const {
        caseInfo: { caseCode },
        imgType
      } = this
      const routeUrl = this.$router.resolve({
        path: '/showImg',
        query: {
          caseCode,
          type: imgType,
          t: new Date().getTime()
        }
      })

      window.open(routeUrl.href, '_blank')
    },

    /**
     * 将tif、tiff格式的图片文件转换成canvas并显示
     * @param {string} url 文件的网络地址
     */
    async tiffImage(url) {
      if (Comm.hasTiff(url)) {
        const result = await Comm.getTif({ url: url, w: 125, h: 125, isScale: true })
        const { index, canvasType } = this
        const id = canvasType + index
        // 先清空元素内的内容，避免重复显然canvas内容
        document.getElementById(id).innerHTML = ''
        document.getElementById(id).append(result)
      }
    },

    /**
     * 预览PDF文件
     */
    onNavsToPDFFile(e, url) {
      e.preventDefault()
      const { appPath } = this
      const newUrl =
        appPath + '/case/createPdfStream/?urlPath=' + encodeURIComponent(url)
      window.open(newUrl, '_blank')
    },

    /**
     * 判断当前文件是否为tif/tiff的文件格式
     * @param {string} url 文件的网络地址
     */
    _isTifFileFormat(url) {
      url = this._caseConversion(url)
      if (url && (url.substr(-3).includes('tif') || url.substr(-4).includes('tiff'))) {
        this.tiffImage(url)
        return true
      } else {
        return false
      }
    },

    /**
     * 判断当前文件是否为文档的文件格式
     * @param {string} url 文件的网络地址
     */
    _isDocumentFileFormat(url) {
      url = this._caseConversion(url)
      if (url && (url.substr(-3).includes('doc') || url.substr(-4).includes('docx'))) {
        return true
      } else {
        return false
      }
    },

    /**
     * 判断当前文件是否为PDF的文件格式
     * @param {string} url 文件的网络地址
     */
    _isPDFFileFormat(url) {
      url = this._caseConversion(url)
      if (url && url.substr(-3).includes('pdf')) {
        return true
      } else {
        return false
      }
    },

    /**
     * 判断当前文件是否为MP3的文件格式
     * @param {string} url 文件的网络地址
     */
    _isMP3FileFormat(url) {
      url = this._caseConversion(url)
      if (url && url.substr(-3).includes('mp3')) {
        return true
      } else {
        return false
      }
    },

    /**
     * 将文件名转小写字母
     */
    _caseConversion(name) {
      return name.toLowerCase()
    }
  }
}
</script>

<style></style>
